import { toLocalISO } from "src/utils/date";
import { KOAH_CODES } from "../model";

export const clamp = (value: any, maxLen: number) => {
    if (value === null || value === undefined) return "";
    const str = String(value);
    return str.length > maxLen ? str.slice(0, maxLen) : str;
};

export const digitsClamp = (value: any, maxLen: number) => {
    if (value === null || value === undefined) return "";
    const str = String(value).replace(/\D+/g, "");
    return str.length > maxLen ? str.slice(0, maxLen) : str;
};

export const checkHasKoah = (patientInfo: any) => {
    const codesText = String(patientInfo?.diseasecodes ?? patientInfo?.DISEASE_CODES ?? "");
    if (!codesText) return false;
    const upper = codesText.toUpperCase();
    return KOAH_CODES.some((c) => upper.includes(c));
};

export const toVarchar = (value: any, maxLen: number) => {
    if (value === null || value === undefined) return "";
    const str = String(value).trim();
    return str.length > maxLen ? str.slice(0, maxLen) : str;
};

export const mapVitalToApi = (data: any) => ({
    body_temperature: toVarchar(data.BODY_TEMPERATURE, 4),
    meas_method_of_body_temp: Number(data.MEAS_METHOD_OF_BODY_TEMP) || 0,
    heart_rate: toVarchar(data.HEART_RATE, 3),
    heart_rate_type: Number(data.HEART_RATE_TYPE) || 0,
    sys: toVarchar(data.SYS, 3),
    dia: toVarchar(data.DIA, 3),
    respiratory_count: toVarchar(data.RESPIRATORY_COUNT, 3),
    respiratory_count_type: Number(data.RESPIRATORY_COUNT_TYPE) || 0,
    respiratory_distress: Number(data.RESPIRATORY_DISTRESS) || 0,
    siyoneze_circulation_disorder: Number(data.SIYONEZE_CIRCULATION_DISORDER) || 0,
    is_taken_o2: Number(data.IS_TAKEN_O2) || 0,
    o2_amount: toVarchar(data.O2_AMOUNT, 2),
    o2_unit: Number(data.O2_UNIT) || 0,
    level_of_consciousness: Number(data.LEVEL_OF_CONSCIOUSNESS) || 0,
    pain_level: Number(data.PAIN_LEVEL) || 0,
    defakasyon: Number(data.DEFAKASYON) || 0,
    urine: Number(data.URINE) || 0,
    early_warning_score: toVarchar(data.EARLY_WARNING_SCORE, 2),
    write_on_epicrise:
        data.WRITE_ON_EPICRISE === undefined ||
            data.WRITE_ON_EPICRISE === null ||
            data.WRITE_ON_EPICRISE === ""
            ? "0"
            : toVarchar(data.WRITE_ON_EPICRISE, 1),
    o2_saturuzation: toVarchar(data.O2_SATURUZATION, 3),
    ptime: toLocalISO(data.PTIME) ?? null,
    capillary_circulation: Number(data.CAPILLARY_CIRCULATION) || 0,
    birth_pain: Number(data.BIRTH_PAIN) || 0,
    birth_losia: Number(data.BIRTH_LOSIA) || 0,
    birth_proteinuria: Number(data.BIRTH_PROTEINURIA) || 0,
    koah_saturation: Number(data.KOAH_SATURATION) || 0,
    evaulation: Number(data.EVAULATION) || 0,
});
